// src/lib/bezierEasing.js
// Samples a CSS-style cubic-bezier(x1,y1,x2,y2) curve so JS can read the
// same easing a CSS `transition` is using — used to time the spin wheel's
// tick sounds against its actual on-screen deceleration instead of guessing.

const SAMPLES = 200;

// Returns easing(t): t (0..1 elapsed fraction) -> eased progress (0..1),
// matching cubic-bezier(x1,y1,x2,y2) as CSS would render it.
export function createCubicBezierEasing(x1, y1, x2, y2) {
    const points = [];
    for (let i = 0; i <= SAMPLES; i++) {
        const t = i / SAMPLES;
        const mt = 1 - t;
        const x = 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t;
        const y = 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t;
        points.push([x, y]);
    }

    return function easing(x) {
        if (x <= 0) return 0;
        if (x >= 1) return 1;

        let lo = 0;
        let hi = points.length - 1;
        while (lo < hi - 1) {
            const mid = (lo + hi) >> 1;
            if (points[mid][0] < x) lo = mid;
            else hi = mid;
        }

        const [x0, y0] = points[lo];
        const [x1s, y1s] = points[hi];
        const span = x1s - x0;
        const frac = span > 0 ? (x - x0) / span : 0;
        return y0 + (y1s - y0) * frac;
    };
}
